(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/XPElementBase',["require", "exports"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Base XP Rule Element, knows how to maps attributes from xml to an element instance
     */
    var XPElementBase = /** @class */ (function () {
        function XPElementBase(attributes) {
            if (!attributes) {
                throw new Error("Cannot initialize XperienceElement without attribute");
            }
            this.applyAttributes(attributes);
        }
        /**
         * Loop through passed object properties and creates/assigns values to the current instance
         * @param {XPAttributes} attributes A dynamic object with properties
         */
        XPElementBase.prototype.applyAttributes = function (attributes) {
            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    // Defined properties on XElement will be populated with a value, the rest will be added as new properties.
                    if (key in this) {
                        this[key] = attributes[key];
                    }
                    else {
                        Object.defineProperty(this, key, { value: attributes[key], enumerable: !1, writable: !0, configurable: !0 });
                    }
                }
            }
        };
        return XPElementBase;
    }());
    exports.XPElementBase = XPElementBase;
});
//# sourceMappingURL=XPElementBase.js.map;
